import { useState, useEffect, useCallback } from 'react';
import { DashboardService } from '../services/DashboardService';
import { TypesService } from '../services/TypesService';
import { UsuarioService } from '../services/UsuarioService';

export const useDashboardMetrics = (token) => {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  
  const [estados, setEstados] = useState([]);
  const [supervisores, setSupervisores] = useState([]);
  
  const [chartsData, setChartsData] = useState({
    regiones: [],
    topVendedores: [],
    porProductos: [],
    evolucionMensual: [],
    porProvincias: [],
    recaudacionMensual: [],
  });

  useEffect(() => {
    if (!token) return;
    const loadStaticData = async () => {
      try {
        const [statusData, supervisors] = await Promise.all([
          TypesService.get({ token, table: 'estado_cliente' }),
          UsuarioService.fetchSupervisores(token)
        ]);
        setEstados(statusData);
        setSupervisores(supervisors);
      } catch (err) {
        console.error("Error cargando datos estáticos", err);
      }
    };
    loadStaticData();
  }, [token]);

  const fetchData = useCallback(async (fechaInicio, fechaFin, estadoSeleccionado, filtroSupervisor) => {
    setLoading(true);
    setError(null);
    try {
      const data = await DashboardService.getInfo(token, fechaInicio, fechaFin, estadoSeleccionado, filtroSupervisor);
      setStats(data.stats);
      setChartsData({
        regiones: data.porRegiones,
        topVendedores: data.topVendedores,
        porProductos: data.porProductos,
        evolucionMensual: data.evolucionMensual,
        porProvincias: data.porProvincias,
        recaudacionMensual: data.recaudacionMensual,
      });
    } catch (err) {
      console.error("Error cargando métricas", err);
      setError("Error al cargar las estadísticas.");
    } finally {
      setLoading(false);
    }
  }, [token]);

  return { 
    stats, 
    loading, 
    error, 
    estados, 
    supervisores, 
    chartsData, 
    fetchData 
  };
};